import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { base_url } from '../../utilities'
import FormLoader from '../Reusable_Components/FromLoader'
import AlertPopUp from '../Reusable_Components/Alert'
import { BsFillInfoCircleFill } from "react-icons/bs";
import { eleminateSpacesAtStartOfInputField, processAndValidateEmail, validateValue } from '../Reusable_Components/ReusableFunctions'
import TableComponent from '../Reusable_Components/TableComponent'

export default function AddEmailTemplate({ setPage, viewMode = false, selectedTemplate = null, setReloadEmailTemplates, reloadEmailTemplates }) {

    const [loader, setLoader] = useState(false)

    const [focused, setFocused] = useState(null)
    const [templateName, setTemplateName] = useState('')
    const [subject, setSubject] = useState('')
    const [body, setBody] = useState('')
    const [templateType, setTemplateType] = useState('')
    const [templateTypeOptions, setTemplateTypeOptions] = useState([])
    const [invoiceType, setInvoiceType] = useState('')
    const [invoiceTypes, setÌnvoiceTypes] = useState([])
    const [options, setOptions] = useState([])
    const [addEmailSuccess, setAddEmailSuccess] = useState(null)
    const [error, setError] = useState(null)
    const [editMode, setEditMode] = useState(false)
    const [templateNameError, setTemplateNameError] = useState(null)
    const [templateTypeError, setTemplateTypeError] = useState(null)
    const [invoiceTypeError, setInvoiceTypeError] = useState(null)
    const [subjectError, setSubjectError] = useState(null)
    const [bodyError, setBodyError] = useState(null)
    const [isDefault, setIsDefault] = useState(1)
    // const [footerError, setFooterError] = useState(null)
    // const [footer, setFooter] = useState('')
    const [ccEmailsData, setCCEmailsData] = useState([])

    //AlertPopUp state variables

    const [alertShow, setAlertShow] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertValue, setAlertValue] = useState('');
    const [alertMessage, setAlertMessage] = useState('');
    const [alertButtons, setAlertButtons] = useState([]);

    //Loading

    const [newlyAddedEmails, setNewlyAddedEmails] = useState([]);
    const [ccEmailInput, setCCEmailInput] = useState('');
    const [isDuplicateEmail, setIsDuplicateEmail] = useState(false);
    const [deleteCCEmailSelectedIndex, setDeleteCCEmailSelectedIndex] = useState();
    const [deleteCCEmailSelected, setDeleteCCEmailSelected] = useState();
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [allEmails, setAllEmails] = useState([...ccEmailsData, ...newlyAddedEmails]);
    const handleConfirmRemoveCCEmail = (email, index) => {
        if (email?.email_cc_master_id) {
            setDeleteCCEmailSelectedIndex(email?.email_cc_master_id);
            setDeleteCCEmailSelected(email);

            setAlertShow(true);
            setAlertType('question');
            setAlertValue(`Are you sure you want to remove this ${email?.cc_email}?`);
            setAlertButtons([
                {
                    name: 'Cancel',
                    action: () => setAlertShow(false)
                },
                {
                    name: 'Proceed',
                    action: () => handleRemoveCCEmail(email?.email_cc_master_id)
                }
            ]);
        } else {
            const updatedNewlyAddedEmails = newlyAddedEmails.filter((_, i) => i !== index - ccEmailsData.length);
            setNewlyAddedEmails(updatedNewlyAddedEmails);
            const updatedAllEmails = allEmails.filter((_, i) => i !== index);
            setAllEmails(updatedAllEmails);
        }
    }

    const handleRemoveCCEmail = (index) => {
        setLoader(true)
        axios.delete(base_url + `email/emailTemplate/emailTemplateEmailCCRef`, {
            params: {
                email_cc_master_id: index,
                email_template_master_id: selectedTemplate?.email_template_master_id
            }
        })
            .then((response) => {
                if (response?.data?.data[0] === 'error') {
                    setLoader(false)
                    setAlertShow(true)
                    setAlertType('error')
                    setAlertMessage('Error')
                    setAlertValue(response?.data?.data[1].message)
                    setAlertButtons([
                        {
                            name: 'Close', action: () => {
                                setAlertShow(false)
                            }
                        },
                    ])
                    setLoader(false)
                }
                else {
                    setLoader(false)
                    const updatedCCEmailsData = ccEmailsData.filter(email => email.email_cc_master_id !== index);
                    setCCEmailsData(updatedCCEmailsData);
                    const updatedAllEmails = allEmails.filter(email => email.email_cc_master_id !== index);
                    setAllEmails(updatedAllEmails);
                    setAlertShow(false);
                }
            })
            .catch((error) => {
                setLoader(false)
                setAlertShow(true)
                setAlertType('error')
                setAlertMessage('Error')
                setAlertValue(error?.response?.data.message)
                setAlertButtons([{
                    name: 'Close', action: () => {
                        setAlertShow(false)
                    }
                }])
                setLoader(false)
            })
    }
    const handleCCEmailInput = (e) => {
        const input = e.target.value;
        const { processedInput, isValid } = processAndValidateEmail(input, ccEmailsData);
        setCCEmailInput(processedInput);
        setIsValidEmail(isValid);
        const allEmailsList = [...ccEmailsData, ...newlyAddedEmails];
        const isDuplicate = allEmailsList.some(emailObj => emailObj.cc_email === processedInput);
        setIsDuplicateEmail(isDuplicate);
    }

    const handleAddCCEmail = () => {
        if (isValidEmail && !isDuplicateEmail && ccEmailInput) {
            const newEmailObj = { cc_email: ccEmailInput }; // No cc_email_id for new
            setNewlyAddedEmails([...newlyAddedEmails, newEmailObj]);
            setCCEmailInput('');
            setAllEmails([...allEmails, newEmailObj]);
        }
    }

    const getListOfValues = (value, setState) => {
        let filter_condition = encodeURIComponent(JSON.stringify({ lov_code: value }))
        axios.get(base_url + `listOfValues?filter_condition=${filter_condition}`)
            .then((res) => {
                setState && setState(res?.data?.data)
                // console.log(res)
            })
            .catch((err) => {
                setError(err?.response?.data?.message)
                console.log(err)
            })
    }

    const getServiceTypes = (value, setState) => {
        axios.get(base_url + `customers/serviceTypes`)
            .then((res) => {
                setState && setState(res?.data?.data)
                // console.log(res)
            })
            .catch((err) => {
                setError(err?.response?.data?.message)
                console.log(err)
            })
    }

    useEffect(() => {
        if (viewMode && selectedTemplate) {
            setTemplateName(selectedTemplate?.template_name)
            setTemplateType(selectedTemplate?.template_type)
            setCCEmailsData(selectedTemplate?.cc_list)
            setInvoiceType(selectedTemplate?.sub_category)
            setSubject(selectedTemplate?.subject)
            setBody(selectedTemplate?.body_text)
            setInvoiceType(selectedTemplate?.sub_category)
            setIsDefault(selectedTemplate?.is_default)
            if (selectedTemplate?.template_type === "Invoice Email") {
                getListOfValues("INVOICE_DETAILS", setOptions)
            }
            else if (selectedTemplate?.template_type === "Payment Email") {
                getListOfValues("PAYMENT_DETAILS", setOptions)
            }
            setEditMode(false)
        } else {
            getListOfValues('EMAIL_TEMPLATE_TYPE', setTemplateTypeOptions)
        }
    }, [reloadEmailTemplates])

    const handleAddEmailTemplate = () => {
        setLoader(true)


        // let footerText = body.split(/\n{2,}/) // Split by double or more newlines
        //     .map(paragraph => {
        //         return `
        //         <p>${paragraph}</p>
        //         `
        //     }).join('')
        let headerText = body.split(/\n{2,}/) // Split by double or more newlines
            .map(paragraph =>
                paragraph
                    .split('\n') // Split by single newline within the paragraph
                    .map(line => `<br>${line}`) // Wrap each line with <br>
                    .join('') // Join lines within the paragraph
            )
            .map(paragraph => `<p>${paragraph}</p>`) // Wrap each paragraph with <p>
            .join('');
        let paymentHtml = `
        <!DOCTYPE html>
        <html>
        <head>
          <style>
            .dues-table-container {{
                margin-top: 20px;
                width: 100%;
                background-color: white;
            }}

            .dues-table {{
                width: 95%;
                margin: auto;
                border-collapse: collapse;
            }}

            .dues-table thead .table-main-header {{
                background-color: #e6e6e6;
                border: 1px solid gray;
                color: #000;
                font-size: 14px;
                font-style: normal;
                font-weight: bold;
                line-height: normal;
                text-align: center;
                padding: 10px;
                vertical-align: top;
            }}

            .dues-table thead .table-sub-header {{
                background-color: #e6e6e6;
                border: 1px solid gray;
                color: #000;
                font-size: 14px;
                font-style: normal;
                font-weight: normal;
                line-height: normal;
                text-align: center;
                padding: 6px;
            }}

            .dues-table tbody th {{
                color: #000;
                font-size: 12px;
                font-style: normal;
                font-weight: 400;
                line-height: normal;
                text-align: center;
                border: 1px solid gray;
                padding: 6px;
            }}

            .dues-table .total th {{
                font-size: 16px;
                border: 0px;
                font-weight: bold;
            }}
          </style>
        </head>
        <body>
            <p>${headerText}</p>
            <div class="dues-table-container">
              {table_html}
            </div>
        </body>
        </html>`

        let subcategory = ''
        if (templateType === "Invoice Email") {
            subcategory = invoiceType
        }
        else if (templateType === "Payment Email") {
            subcategory = "invoicePayment"
        }

        let htmlBody = body
            .split(/\n{2,}/) // Split by double or more newlines
            .map(paragraph =>
                paragraph
                    .split('\n') // Split by single newline within the paragraph
                    .map(line => `<br>${line}`) // Wrap each line with <br>
                    .join('') // Join lines within the paragraph
            )
            .map(paragraph => `<p>${paragraph}</p>`) // Wrap each paragraph with <p>
            .join(''); // Join all paragraphs
        htmlBody = `<!DOCTYPE html><html><head></head><body>${htmlBody}</body></html>`
        const ccEmails = [...ccEmailsData, ...newlyAddedEmails];
        const payload = {
            template_name: templateName,
            template_type: templateType,
            sub_category: subcategory,
            subject: subject,
            body_html: templateType === "Payment Email" ? paymentHtml : htmlBody,
            body_text: body,
            is_default: isDefault,
            cc_list: ccEmails
        }

        if (viewMode && selectedTemplate && editMode) {
            axios.put(base_url + 'email/emailTemplate', { ...payload, email_template_master_id: selectedTemplate?.email_template_master_id })
                .then((res) => {
                    setLoader(false)
                    setAddEmailSuccess(payload?.template_name + " updated successfully")
                    setNewlyAddedEmails([])
                })
                .catch((err) => {
                    setLoader(false)
                    setError(err?.response?.data?.message)
                    console.log(err)
                })
        }
        else {
            axios.post(base_url + 'email/emailTemplate', payload)
                .then((res) => {
                    setLoader(false)
                    setAddEmailSuccess(payload?.template_name + " added successfully")
                    setNewlyAddedEmails([])
                })
                .catch((err) => {
                    setLoader(false)
                    setError(err?.response?.data?.message)
                    console.log(err)
                })
        }
        // console.log(payload, "payload")
    }

    return (
        <div className='addUserContainer'>
            <AlertPopUp alertShow={alertShow} alertType={alertType} alertMsg={alertMessage} alertValue={alertValue} alertButtons={alertButtons} />
            <div className="stepsContainer">
                <div className="stepsTitle">
                    <h6 style={{ padding: "20px", lineHeight: "0px" }}>Add New Email Template</h6>
                </div>
                <div className={'stepsCardActive'}>
                    <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                        <span style={{ fontWeight: "bold", fontSize: "medium" }}>Email Information</span>
                    </div>
                    <span style={{ fontSize: "small", marginTop: "10px" }}>Email Details</span>
                </div>
            </div>
            <div className="infoContainer" style={{ display: "flex", flexDirection: "row" }}>
                <div style={{ flex: "1 1 auto" }}>
                    <div className="infoTitle">
                        <h6 style={{ padding: "20px", lineHeight: "0px" }}>1. Email Information</h6>
                    </div>
                    <div className="infoBody" style={{ paddingTop: "0px" }}>
                        <div className="d-flex justify-content-end align-items-center gap-2 mt-3">
                            <div className="form-check form-switch">
                                <input
                                    style={{ height: "20px", width: "40px" }}
                                    className="form-check-input"
                                    type="checkbox"
                                    id="setAsDefaultToggle"
                                    checked={isDefault === 1}
                                    onChange={(e) => setIsDefault(e.target.checked ? 1 : 0)}
                                    disabled={viewMode && !editMode}
                                />
                            </div>
                            <label className='add-facility-modal-label' htmlFor='setAsDefaultToggle'>Set as Default</label>
                        </div>
                        <div className="inputsSection">
                            <div>
                                <label className='add-facility-modal-label'>Email Template Name <span style={{ color: "red" }}>*</span></label>
                                <input
                                    type='text'
                                    className='form-control responsive-add-facility-input-fields'
                                    value={templateName}
                                    disabled={viewMode}
                                    onChange={(e) => {
                                        let value = e.target.value;
                                        value = value.replace(/[^a-zA-Z0-9./\\\-_]+/g, '');
                                        value = value.trim();
                                        if (/^[0-9]+$/.test(value)) {
                                            return;
                                        }
                                        if (validateValue(value.charAt(0))) {
                                            setTemplateName(value);
                                            const lengthValid = value.length >= 3 && value.length <= 200;
                                            if (!lengthValid) {
                                                setTemplateNameError("Minimum 3 characters required");
                                            } else {
                                                setTemplateNameError(null);
                                            }

                                        }
                                        else {
                                            e.target.value = templateName;
                                        }

                                    }}
                                />
                                {templateNameError && <span className='text-danger' style={{ fontSize: "small" }}>{templateNameError}</span>}
                            </div>
                            <div>
                                <label className='add-facility-modal-label'>Template Type<span style={{ color: "red" }}>*</span> </label>
                                {viewMode && templateType ?
                                    <input type='text' className='form-control responsive-add-facility-input-fields' value={templateType} disabled />
                                    : <select className='form-select responsive-add-facility-input-fields' value={templateType} onChange={(e) => {
                                        if (e.target.value === "Invoice Email") {
                                            getServiceTypes('INVOICE_TYPE', setÌnvoiceTypes)
                                            getListOfValues("INVOICE_DETAILS", setOptions)
                                        }
                                        else if (e.target.value === "Payment Email") {
                                            getListOfValues("PAYMENT_DETAILS", setOptions)
                                        }
                                        let input = e.target.value;
                                        setTemplateType(input);
                                        setSubject("");
                                        setBody("");
                                        if (input === "") {
                                            setTemplateTypeError("Template type is required");
                                        } else {
                                            setTemplateTypeError(null);
                                        }
                                    }} style={{ height: "40px", border: "1px solid #D3D3D3" }}>
                                        <option value="" hidden>Select</option>
                                        {templateTypeOptions.map((option, index) => (
                                            <option key={index} value={option.lov_value}>{option.lov_value}</option>
                                        ))}
                                    </select>}
                            </div>
                        </div>
                        {templateType === "Invoice Email" && (
                            viewMode && invoiceType ? (
                                <div className='mt-3'>
                                    <label className='add-facility-modal-label'>Invoice Type<span style={{ color: "red" }}>*</span> </label>
                                    <input type='text' className='form-control responsive-add-facility-input-fields' value={invoiceType} disabled />
                                </div>
                            ) : invoiceTypes.length > 0 && (
                                <div className='mt-3'>
                                    <label className='add-facility-modal-label'>Invoice Type<span style={{ color: "red" }}>*</span> </label>
                                    <select className='form-select responsive-add-facility-input-fields' style={{ height: "40px", border: "1px solid #D3D3D3" }}
                                        onChange={(e) => {
                                            let input = e.target.value;
                                            setInvoiceType(input);
                                            if (input === "") {
                                                setInvoiceTypeError("Invoice type is required");
                                            } else {
                                                setInvoiceTypeError(null);
                                            }
                                        }}
                                        value={invoiceType}
                                    >
                                        <option value="" hidden>Select</option>
                                        <option value="miscellaneous">Miscellaneous</option>
                                        {invoiceTypes.map((option, index) => (
                                            <option key={index} value={option.service_code}>{option.service_name}</option>
                                        ))}
                                    </select>
                                </div>
                            )
                        )}
                        {(templateType !== "Set Password Email" && templateType !== "OTP Email") && (
                            <div className='d-flex flex-column gap-2 inputsSection'>
                                <label>CC Email</label>
                                {!viewMode || editMode ? (
                                    <div className={`d-flex gap-2 position-relative`} style={{ minHeight: '48px' }}>
                                        <div style={{ position: 'relative' }}>
                                            <input
                                                type='email'
                                                id='cc-email-input'
                                                className='form-control responsive-add-facility-input-fields'
                                                placeholder='Enter email address'
                                                value={ccEmailInput}
                                                onChange={(e) => { handleCCEmailInput(e) }}
                                                style={{ marginBottom: 0 }}
                                            />
                                            {!isValidEmail && (
                                                <span className='text-danger' >Invalid Email Address</span>
                                            )}
                                            {isDuplicateEmail && (
                                                <span className='text-danger' >Email already exist</span>
                                            )}
                                        </div>
                                        <button disabled={!isValidEmail || isDuplicateEmail || ccEmailInput === ""} onClick={handleAddCCEmail} className="btn btn-secondary cc-email-button" style={{ padding: '6px 12px', fontSize: '14px', height: '36px' }} >
                                            <img src='./images/icons/AddIcon.svg' alt='add' />Add
                                        </button>
                                    </div>) : null}
                                <div className='d-flex flex-wrap align-items-center mt-2 cc-emails-container'>
                                    {[...ccEmailsData, ...newlyAddedEmails].map((email, index) => (
                                        <p key={email.email_cc_master_id ? email.email_cc_master_id : index} className='cc-list-items'>
                                            {email.cc_email} {viewMode && !editMode ? null : <img onClick={() => handleConfirmRemoveCCEmail(email, index)} className='wrong-icon' src='./images/icons/WrongIcon.svg' alt='remove' />}
                                        </p>
                                    ))}
                                    
                                </div>
                            </div>)}
                        <hr />
                        {viewMode && !editMode ? null : <p style={{ marginBottom: 0, color: "#669df1" }} className='input-description d-flex align-items-center gap-2'><BsFillInfoCircleFill />Default template will be used if subject and body fields are left empty.</p>}
                        <div className='d-flex flex-column justify-content-center gap-2 inputsSection'>
                            <label>Subject</label>
                            <div>
                                <input type="text" value={subject} placeholder='Enter subject' disabled={viewMode && !editMode} className='form-control' onFocus={() => setFocused("subject")} onChange={(e) => {
                                    let input = e.target.value;
                                    input = eleminateSpacesAtStartOfInputField(input)
                                    setSubject(input);
                                    if (input.trim() === "") {
                                        setSubjectError("Subject is required");
                                    } else if (input.length < 3) {
                                        setSubjectError("Minimum 3 characters required");
                                    } else {
                                        setSubjectError(null);
                                    }
                                }} />
                            </div>
                        </div>
                        <div className='d-flex flex-column gap-2 inputsSection'>
                            <label>Body</label>
                            <div>
                                <textarea type="text" placeholder='Enter body text' rows={7} disabled={viewMode && !editMode} value={body} className='form-control' onFocus={() => setFocused("body")} onChange={(e) => {
                                    let input = e.target.value;
                                    input = eleminateSpacesAtStartOfInputField(input);
                                    const trimmedValue = input.trimStart();
                                    setBody(trimmedValue);
                                    if (trimmedValue === "" || trimmedValue.trimEnd() === "") {
                                        setBodyError("Body is required");
                                    } else if (trimmedValue.length < 10) {
                                        setBodyError("Minimum 10 characters required");
                                    } else {
                                        setBodyError(null);
                                    }
                                }} />
                            </div>
                        </div>
                        {templateType === "Payment Email" &&
                            <div className='d-flex flex-column gap-2 inputsSection'>
                                <TableComponent
                                    headers={[{
                                        name: "Nature of Income",
                                        type: "text",
                                        key: "nature_of_income",

                                    }, {
                                        name: "Invoice Number",
                                        type: "text",
                                        key: "invoice_number",
                                    }, {
                                        name: "Invoice Date",
                                        type: "date",
                                        key: "invoice_date",
                                    }, {
                                        name: "Due Date",
                                        type: "date",
                                        key: "due_date",
                                    }, {
                                        name: `Invoice Amount (${localStorage.getItem("currency_format")})`,
                                        type: "number",
                                        key: "invoice_amount",
                                    }, {
                                        name: `TDS Amount (${localStorage.getItem("currency_format")})`,
                                        type: "number",
                                        key: "tds_amount",
                                    }, {
                                        name: `Amount Receivable (${localStorage.getItem("currency_format")})`,
                                        type: "number",
                                        key: "amount_receivable",
                                    }

                                    ]}
                                    data={[]}
                                />
                            </div>}
                    </div>
                    <div className="infoFotter">
                        <div className="button-group d-flex justify-content-end gap-3">
                            <button className="btn btn-secondary" onClick={() => { setPage(1); setReloadEmailTemplates(!reloadEmailTemplates) }} >Back</button>
                            {viewMode && !editMode ? <button className="btn btn-secondary" onClick={() => setEditMode(true)}>Edit</button> :
                                editMode ? <>
                                    <button className="btn btn-secondary" onClick={() => { setEditMode(false); setCCEmailInput(''); setIsDuplicateEmail(false); }}>Cancel</button>
                                    <button className="btn btn-secondary" disabled={
                                        templateNameError || templateTypeError || templateName === "" || templateType === ""
                                    } onClick={() => handleAddEmailTemplate()}>Update</button>
                                </>
                                    : <button className="btn btn-secondary" disabled={
                                        templateNameError || templateTypeError || templateName === "" || templateType === ""
                                    } onClick={handleAddEmailTemplate}>Submit</button>}
                        </div>
                    </div>
                </div>
                <div style={{ flex: "0 1 auto", width: "30%", borderLeft: "1px solid #e0e0e0" }} >
                    <div className="infoTitle">
                        <h6 style={{ padding: "20px", lineHeight: "0px" }}>Options</h6>
                    </div>
                    <div className="infoBody" style={{ paddingTop: "0px" }}>
                        {options?.map((option, index) => (
                            <div key={index} className='d-flex gap-2' style={{ marginTop: "20px" }}>
                                <button className="btn btn-secondary form-control responsive-add-facility-input-fields" style={{ padding: "5px 10px", fontSize: "small" }} onClick={
                                    () => {
                                        const insertAtCursor = (field, value) => {
                                            const cursorPosition = field.selectionStart;
                                            const textBeforeCursor = field.value.substring(0, cursorPosition);
                                            const textAfterCursor = field.value.substring(cursorPosition);
                                            field.value = textBeforeCursor + value + textAfterCursor;
                                            field.selectionStart = field.selectionEnd = cursorPosition + value.length; // Move cursor after inserted text
                                        };

                                        if (focused === "subject") {
                                            const subjectField = document.querySelector('input[placeholder="Enter subject"]');
                                            const cursorPosition = subjectField.selectionStart;
                                            const textBeforeCursor = subject.substring(0, cursorPosition);
                                            const textAfterCursor = subject.substring(cursorPosition);
                                            const newValue = textBeforeCursor + `{${option?.lov_value}}` + textAfterCursor;
                                            setSubject(newValue);

                                            // Add validation here
                                            if (newValue === "") {
                                                setSubjectError("Subject is required");
                                            } else if (newValue.length < 3) {
                                                setSubjectError("Minimum 3 characters required");
                                            } else {
                                                setSubjectError(null);
                                            }
                                        } else if (focused === "body") {
                                            const bodyField = document.querySelector('textarea[placeholder="Enter body text"]');
                                            const cursorPosition = bodyField.selectionStart;
                                            const textBeforeCursor = body.substring(0, cursorPosition);
                                            const textAfterCursor = body.substring(cursorPosition);
                                            const newValue = textBeforeCursor + `{${option?.lov_value}}` + textAfterCursor;
                                            setBody(newValue);

                                            // Add validation here
                                            if (newValue.trim() === "") {
                                                setBodyError("Body is required");
                                            } else if (newValue.length < 10) {
                                                setBodyError("Minimum 10 characters required");
                                            } else {
                                                setBodyError(null);
                                            }
                                        }
                                        //  else if (focused === "footer") {
                                        //     const footerField = document.getElementById('footer-textarea');
                                        //     insertAtCursor(footerField, `{${option?.lov_value}}`);
                                        //     setFooter(footerField.value);
                                        // }
                                    }
                                }>{option?.lov_value}</button>
                            </div>
                        ))
                        }
                    </div>
                </div>
            </div>
            {addEmailSuccess && <AlertPopUp
                alertShow={addEmailSuccess}
                alertType="success"
                alertMsg={"Success"}
                alertValue={addEmailSuccess}
                alertButtons={[{
                    name: "Close", action: () => {
                        setAddEmailSuccess(null)
                        setPage(1)
                        setReloadEmailTemplates(!reloadEmailTemplates)
                    }
                }]}
            />}
            {error && <AlertPopUp
                alertShow={error}
                alertType="error"
                alertMsg={"Error"}
                alertValue={error}
                alertButtons={[{
                    name: "Close", action: () => {
                        setError(null)
                    }
                }]}
            />}
            {loader && <FormLoader />}
        </div>
    )
}
